document.addEventListener('DOMContentLoaded', function() {
  const tabNames = document.querySelectorAll('.howuse-tabname');
  const textWrappers = document.querySelectorAll('.howuse-txt-wrapper');
  const images = document.querySelectorAll('.howuse-img');

  tabNames.forEach(tab => {
    tab.addEventListener('click', function() {
      tabNames.forEach(tab => tab.classList.remove('active'));
      this.classList.add('active');
      textWrappers.forEach(wrapper => wrapper.classList.remove('active'));
      const activeWrapperId = this.getAttribute('data-tab');
      const activeWrapper = document.getElementById(activeWrapperId);
      if (activeWrapper) {
        activeWrapper.classList.add('active');
      }
      images.forEach(img => img.classList.remove('active'));
      const activeTab = this.getAttribute('data-tab');
      const activeImage = document.querySelector(`.howuse-img[data-tab="${activeTab}"]`);
      if (activeImage) {
        activeImage.classList.add('active');
      }
    });
  });

  const accordionTitles = document.querySelectorAll('.howuse-accordion-title');

  accordionTitles.forEach(title => {
    title.addEventListener('click', function() {
      const body = this.nextElementSibling;
      if (body.classList.contains('active')) {
        body.classList.remove('active');
        this.querySelector('.accordion-icon i').classList.remove('bi-dash-lg');
        this.querySelector('.accordion-icon i').classList.add('bi-plus-lg');
      } else {
        document.querySelectorAll('.howuse-accordion-body').forEach(b => {
          b.classList.remove('active');
        });
        document.querySelectorAll('.accordion-icon i').forEach(icon => {
          icon.classList.remove('bi-dash-lg');
          icon.classList.add('bi-plus-lg');
        });
        body.classList.add('active');
        this.querySelector('.accordion-icon i').classList.remove('bi-plus-lg');
        this.querySelector('.accordion-icon i').classList.add('bi-dash-lg');
      }
    });
  });
});